module.exports = __webpack_public_path__ + "static/media/decoracoes@2x.5d9ded28.jpg";